import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LexbeDoc } from '@models/doc.model';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { distinctUntilChanged, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';
import { ReviewManager } from '@managers/review.manager';
import { DocumentConextListState } from '@store/doc-viewer/document-list/document-list.state';
import { DocViewerContextDoc } from '@models/ui/doc-viewer-context-doc.model';

@Component({
    selector: 'lex-doc-navigation-list',
    templateUrl: './doc-navigation-list.component.html',
    styleUrls: ['./doc-navigation-list.component.scss'],
    standalone: false
})
export class DocNavigationListComponent extends BaseComponent implements OnChanges {
  @Input() docListState: DocumentConextListState;
  
  public docList: DocViewerContextDoc[] = [];
  public currentDocumentSnapshot: LexbeDoc;
  
  constructor(
    private docViewerStore: DocViewerStore,
    private reviewManager: ReviewManager
  ) {
    super();
    this.docViewerStore.currentDocument$.pipe(
      distinctUntilChanged((a, b) => a.docId === b.docId),
      takeUntil(this.destroy$)
    ).subscribe((snapshot) => this.currentDocumentSnapshot = snapshot);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['docListState'] && changes['docListState'].currentValue) {
      const currentState = changes['docListState'].currentValue;
      this.updateProcessedDocList(currentState);
    }
  }

  public loadDocument(documentId: string): void {
    this.reviewManager.continueWithoutSavingConfirmationDialog().subscribe((confirm) => {
      if (confirm)
        this.reviewManager.loadDocument(documentId);
    });
  }

  public trackByDocId(index: number, doc: DocViewerContextDoc): string {
    return doc.docId;
  }

  private updateProcessedDocList(state: DocumentConextListState): void {
    if (state && state.isExpandedResults) {
      this.docList = state.docList?.map((doc: DocViewerContextDoc, _, collection: DocViewerContextDoc[]) => {
        const hasParentInView = collection.some((docFromCollection) => docFromCollection.docId === doc.parentDocId);
        return { ...doc, hasParentInView };
      }) || [];
    } else {
      this.docList = [...(state?.docList || [])];
    }
  }
}
